const PermanentSearchDialog = {
  Title: 'BÚSQUEDA CONSTANTE',
  Text:
    'Esta empresa está en constante búsqueda de candidatos para el puesto. Si te postulás a este aviso, podrán llamarte ahora o dentro de un tiempo.',
}

export default PermanentSearchDialog
